import { FileText, Mail } from 'lucide-react'
import { GmailMessageView } from './GmailMessageView'
import type { Donation } from '../types/donation'

interface EmailPreviewProps {
  donation: Donation | null
}

export function EmailPreview({ donation }: EmailPreviewProps) {
  if (!donation) {
    return (
      <div className="border rounded-lg p-4 bg-gray-50 w-[600px] min-h-[400px] flex items-center justify-center">
        <div className="text-center text-gray-500">
          <Mail className="mx-auto h-12 w-12 mb-4" />
          <p>Email preview will be displayed here</p>
          <p className="text-sm">
            Select a donation to view the original email
          </p>
        </div>
      </div>
    )
  }

  // Check if this donation has email data
  if (!donation.emailRaw) {
    return (
      <div className="border rounded-lg p-4 bg-gray-50 w-[600px] min-h-[400px] flex items-center justify-center">
        <div className="text-center text-gray-500">
          <FileText className="mx-auto h-12 w-12 mb-4" />
          <p className="font-medium">Manual Donation</p>
          <p className="text-sm">
            This donation was entered manually and doesn't have an associated
            email
          </p>
        </div>
      </div>
    )
  }

  return <GmailMessageView donation={donation} />
}
